import React from "react";
import { useCookies } from "react-cookie";
import { useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Image from "./Image";

function ensureSlashs(path, start, end) {
  let url = path;
  if (start === true) {
    // We're adding slashes to the start
    url = url.startsWith("/") ? url : (url = `/${url}`);
  }
  if (end === true) {
    // We're adding slashes to the end
    url = url.endsWith("/") ? url : (url += "/");
  }
  return url;
}

// ====

const LanguageToggle = ({ settings, location }) => {
  const [, setCookie] = useCookies(["nf_lang"]);

  const country = useSelector((state) => state.global.country);

  const refreshPage = (code, location) => {
    const path = ensureSlashs(
      window.location.pathname && window.location.pathname,
      true,
      true
    ); // Ensure the path has slashes at each side

    let newPath = "";

    if (
      country?.toLowerCase() === "gb" ||
      country?.toLowerCase() === "default"
    ) {
      newPath = path.replace(/\/de\/|\/es\/|\/fr\/|\/it\/|\/zh\//g, `/`); // Replace the country code (inc slashes), if it exists, from "/es/" to "/"
      newPath = `/${code}${newPath}`;
    } else {
      newPath = path.replace(
        /\/de\/|\/es\/|\/fr\/|\/it\/|\/zh\//g,
        `/${code}/`
      ); // Replace the country code (inc slashes), if it exists, from "/es/" to "/"
    }

    setCookie("nf_lang", code, {
      path: "/",
      maxAge: 86400,
      sameSite: "strict",
    }); // Set a cookie

    if (typeof window !== "undefined") {
      window.location.href = newPath;
    }
  };

  const languageList =
    settings.languages &&
    settings.languages.reduce((currList, item, index) => {
      if (item) {
        currList.push(
          <li key={index}>
            <span
              className="dropdown-item"
              to={item.code}
              onClick={() => refreshPage(item.code, location)}
            >
              <Image
                src={item.flag?.filename}
                sm="25x0"
                md="25x0"
                lg="25x0"
                className="me-2"
              />
              {item.name}
            </span>
          </li>
        );
      }
      return currList;
    }, []);

  return (
    <div className="dropdown">
      <button
        className="btn btn-secondary dropdown-toggle"
        type="button"
        id="LanguageSelect"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <FontAwesomeIcon icon="globe" className="me-2" />
        <span> {settings?.language_label}</span>
      </button>
      <ul className="dropdown-menu" aria-labelledby="LanguageSelect">
        {languageList}
      </ul>
    </div>
  );
};

export default LanguageToggle;

// ====

LanguageToggle.propTypes = {};

LanguageToggle.defaultProps = {};
